import styled from 'styled-components';
import { flexCenterAll } from '@honeybook/hbui/dist/styles/mixins';
import { mediumUp } from '@honeybook/hbui/dist/styles/breakpoints';
import { Z_INDEX } from '@honeybook/hbui/dist/styles/variables';
import is from 'styled-is';
import { SettingIconColorProps } from '~/common/IconWrappers/FloatingCogIconWrapper';

export const CogIconWrapper = styled.div<{
    isBlockFocused: boolean;
    isSubLevelIcon: boolean;
    colorProps: Pick<
        SettingIconColorProps,
        'selectedBackgroundColor' | 'unselectedBackgroundColor'
    >;
}>`
    ${flexCenterAll};
    height: ${props => (props.isSubLevelIcon ? '30px' : '40px')};
    width: ${props => (props.isSubLevelIcon ? '30px' : '40px')};
    padding: 8px;
    background-color: ${props =>
        props.isBlockFocused
            ? props.colorProps.selectedBackgroundColor
            : props.colorProps.unselectedBackgroundColor};
    border-radius: 4px;
    box-shadow: 0 2px 8px 0 rgba(0, 0, 0, 0.08), 0 0 0 1px rgba(0, 0, 0, 0.1);
    cursor: pointer;
    ${mediumUp} {
        height: 32px;
        width: 32px;
    }

    i {
        width: 16px;
        height: 16px;
    }
`;

export const RightFloatingCogIcon = styled.div<{
    hasError?: boolean;
    shouldExpandTop?: boolean;
    isTopMobileCog?: boolean;
}>`
    display: none;
    position: absolute;
    z-index: ${Z_INDEX.TOP};
    right: 16px;
    top: 16px;
    ${mediumUp} {
        right: 12px;
        top: 12px;
    }
    ${is('hasError')`
        right: 44px;
    `}
    ${is('shouldExpandTop')`
        top: 78px;
    `}
    ${is('isTopMobileCog')`
        margin-right: 4px;
        margin-top: 10px;
    `}
`;

export const TopClickableCogIcon = styled.div`
    z-index: ${Z_INDEX.TOP};
`;
